// src/features/dashboard/admin/ClassesTable.jsx
import React, { useState, useMemo } from 'react';

export const ClassesTable = ({ classes, onManageClass }) => {
  const [search, setSearch] = useState("");

  const filtered = useMemo(() => {
    if (!search.trim()) return classes;
    const q = search.toLowerCase().trim();
    return classes.filter(c =>
      c.subject.toLowerCase().includes(q) ||
      c.grade.toLowerCase().includes(q) ||
      c.teacher.toLowerCase().includes(q)
    );
  }, [classes, search]);

  return (
    <div className="bg-white rounded-lg shadow overflow-hidden">
      <div className="p-4 border-b border-gray-200 flex flex-wrap gap-3 items-center justify-between">
        <div className="flex flex-wrap gap-2">
          <input
            type="text"
            placeholder="Search subject, grade or teacher..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="border rounded px-3 py-1 text-sm"
          />
        </div>
        <button
          onClick={() => onManageClass(null)}
          className="bg-green-600 text-white px-3 py-1 rounded hover:bg-green-700 text-sm"
        >
          + Add Class
        </button>
      </div>
      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Subject</th>
              <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Grade</th>
              <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Teacher</th>
              <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Students</th>
              <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Actions</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {filtered.length === 0 ? (
              <tr><td colSpan="5" className="px-4 py-3 text-center text-gray-500">No classes found.</td></tr>
            ) : (
              filtered.map((cls) => (
                <tr key={cls.key}>
                  <td className="px-4 py-2">{cls.subject}</td>
                  <td className="px-4 py-2">{cls.grade}</td>
                  <td className="px-4 py-2">{cls.teacher}</td>
                  <td className="px-4 py-2">{cls.studentCount}</td>
                  <td className="px-4 py-2">
                    <button
                      onClick={() => onManageClass(cls)}
                      className="text-blue-600 hover:underline text-sm"
                    >
                      Manage Students
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};